import type {CurrentAuthService} from 'shared/services';
import type {Auth, Department} from 'src/typings';
import type {Observable} from 'rxjs';
import type LoginService from 'shared/login/login.service';
import type {KpDepartmentsService} from 'src/features/departments/services/kp-departments.service';

export class ErpTopbarService {
    public static serviceName = 'erpTopbarService';

    /*@ngInject*/
    constructor(private loginService: LoginService,
                private currentAuthService: CurrentAuthService,
                private kpDepartmentsService: KpDepartmentsService,
                public readonly currentDepartment: Department) {
    }

    public getCurrentAuth$(): Observable<Auth> {
        return this.currentAuthService.currentAuth$();
    }

    public logout(): Promise<void> {
        return this.loginService.logout();
    }

    public async changeCurrentDepartment(department: Department): Promise<void> {
        return this.kpDepartmentsService.changeCurrentDepartment(department);
    }

    public async login(): Promise<void> {
        await this.loginService.login();
    }
}